import React, { useEffect, useState } from "react";
import { useI18n } from "../i18n/LanguageContext";
import { useRequestModal } from "../context/RequestModalContext";
import { LanguageSwitcher } from "./LanguageSwitcher";

const NAV = [
  { key: "services", href: "#aviation" },
  { key: "destinations", href: "#destinations" },
  { key: "concierge", href: "#concierge" },
];

export const Header = () => {
  const { t } = useI18n();
  const { openRequest } = useRequestModal();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? "bg-vm-bg/70 backdrop-blur-xl border-b border-vm-border" : "bg-transparent"}`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" className="flex flex-col leading-none" data-testid="brand-logo">
          <span className="font-serif text-2xl tracking-[0.25em] text-vm-text">VELMONTÉ</span>
          <span className="text-[0.55rem] tracking-[0.35em] uppercase text-vm-muted mt-1 hidden sm:block">Private Office</span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <a key={n.key} href={n.href} className="vm-link text-xs tracking-[0.2em] uppercase" data-testid={`nav-${n.key}`}>
              {t(`nav.${n.key}`)}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-5">
          <LanguageSwitcher />
          <button
            onClick={() => openRequest("other")}
            className="vm-btn-primary hidden sm:inline-flex px-5 py-2.5 text-xs tracking-[0.15em] uppercase"
            data-testid="header-request-button"
          >
            {t("common.makeRequest")}
          </button>
        </div>
      </div>
    </header>
  );
};
